import { render, staticRenderFns } from "./MasterDepreciationTable.vue?vue&type=template&id=1844d114&scoped=true&"
import script from "./MasterDepreciationTable.vue?vue&type=script&lang=js&"
export * from "./MasterDepreciationTable.vue?vue&type=script&lang=js&"
import style0 from "./MasterDepreciationTable.vue?vue&type=style&index=0&id=1844d114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1844d114",
  null
  
)

export default component.exports